// Pure ISO-week helpers for the Sales Weekly Journal.
//
// H9/M11 — the previous inline versions serialized local-midnight Dates with
// `.toISOString().slice(0,10)`, which converts to UTC. In any timezone ahead of
// UTC (e.g. Australia) that shifts the date back a day, so the displayed and
// persisted `week_start` (a Monday) came out as the preceding Sunday and the
// "current week" lock could be off by one. These build the YYYY-MM-DD string
// from LOCAL date parts instead, matching the backend's monday_of() semantics.

/** Format a Date as YYYY-MM-DD using its LOCAL calendar date (no UTC shift). */
export function isoLocal(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** Monday (ISO week) of the week containing `date`, as a local YYYY-MM-DD. */
export function mondayOf(date) {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const dow = d.getDay();            // 0=Sun, 1=Mon, …
  const diff = dow === 0 ? -6 : 1 - dow;
  d.setDate(d.getDate() + diff);
  return isoLocal(d);
}

/** Monday of the current local week, as YYYY-MM-DD. */
export function currentMondayISO() {
  return mondayOf(new Date());
}

/** Mondays between two YYYY-MM-DD dates, inclusive, as local YYYY-MM-DD strings. */
export function mondaysBetween(startStr, endStr) {
  if (!startStr || !endStr) return [];
  const out = [];
  const d = new Date(startStr + 'T00:00:00'); // parsed as local time
  const dow = d.getDay();
  if (dow !== 1) d.setDate(d.getDate() + ((1 + 7 - dow) % 7)); // advance to Monday
  const end = new Date(endStr + 'T00:00:00');
  while (d <= end) {
    out.push(isoLocal(d));
    d.setDate(d.getDate() + 7);
  }
  return out;
}
